import StylesheetService from '../../services/StylesheetService';

export enum STYLESHEET_QUERY_KEYS {
  GET_BRAND_STYLESHEET = 'get-brand-stylesheet',
  GET_GLOBAL_STYLESHEET = 'get-global-stylesheet',
}

const stylesheetService = new StylesheetService();

export const getGlobalStylesheetQueryConfig = () => ({
  queryKey: [STYLESHEET_QUERY_KEYS.GET_GLOBAL_STYLESHEET],
  queryFn: () => stylesheetService.getGlobalStylesheet(),
});

export const getBrandStylesheetQueryConfig = (subscriptionId: string) => ({
  queryKey: [STYLESHEET_QUERY_KEYS.GET_BRAND_STYLESHEET, subscriptionId],
  queryFn: () => stylesheetService.getStylesheet(subscriptionId),
});
